module.exports = __webpack_public_path__ + "static/media/seagull.f908455c.png";